$( function() {
    if($('body').hasClass('trip-search-page')){
        
        var windowsize = $(window).width();
        if (windowsize < 839 ) {
            $(window).on('load', function() {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".trip-search").offset().top
                }, 2000);
            });
        }

        if (windowsize > 839 && $( "#cart" ).length != 0) {
            window.addEventListener('scroll', function(e) {
                window.requestAnimationFrame(function() {
                    stickCart()
                    ticking = false;
                });
            });
        }
        function stickCart() {
            //$(window).scroll(function() {
            var top = $(window).scrollTop();
            if(top > 320) {
                    $('#cart').addClass('fixed-cart');
                } else {
                    $('#cart').removeClass('fixed-cart');
                }
            //});
        }
        
        var coll = document.getElementsByClassName("collapsible");
        var i;
        
        for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            
            if (content.style.display === "block") {
            content.style.display = "none";
            } else {
            content.style.display = "block";
            }
        });
        }
        
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $('.add-to-cart').on('click',function(){
            addToCart($(this));
        });
        if($('.replace-cart').length){
            // $('#trips').on('click','.replace-cart', function(){
            $('.replace-cart').on('click', function(){
            replaceCart($(this));
            })
        }
        function replaceCart(btn){
            $('#cart-items').empty();
            $('#cart-items').addClass('spinner');
            var from = $('#from-id').val();
            var to = $('#to-id').val();
            var departure = $('#departure').data('val');
            var trip_id = btn.data('id');
            var start_time = btn.data('start-time');
            var end_time = btn.data('end-time');
            var round_trip = btn.data('round-trip');
            if($('#return').length){
                var return_date = $('#return').data('val');
            }else{
                var return_date = null;
            }
            var passengers = $('#passengers').val();
            var datas = {
                'from' : from,
                'to' : to,
                'departure' : departure,
                'return' : return_date,
                'passengers' : passengers,
                'start_time' : start_time,
                'end_time' : end_time,
                'trip_id' : trip_id,
                'round_trip': round_trip
            };
            $('.empty-cart').hide();
            $.ajax({
                url: '/update-cart',
                type: "post",
                data:datas,
                success: function (data) {
                    $('#cart-items').removeClass('spinner');
                    if(round_trip == 'back'){
                        $('#cart-items').append(data);
                    }else{
                        $('#cart-items').html(data);
                    }
                    var replace_text = $('.add-to-cart').data('replace-text');
                    var book_text = $('.add-to-cart').data('book-text');
                    btn.removeClass('replace-cart')
                    btn.addClass('cursor-not-allowed bg-grey ')
                    btn.attr('disabled', 'disabled')
                    btn.text(book_text)
                    
                    $('.add-to-cart').addClass('replace-cart')
                    $('.add-to-cart').removeClass('cursor-not-allowed bg-grey ')
                    $('.add-to-cart').removeAttr('disabled')
                    $('.add-to-cart').data('action', 'replace');
                    $('.add-to-cart').text(replace_text)
                    $('.replace-cart').removeClass('add-to-cart')
                    $('.replace-cart').removeClass('cursor-not-allowed bg-grey ')
                    $('.add-to-cart').removeAttr('disabled')
                }
            })
        }
        
        function addToCart(btn){
            $('#cart-items').addClass('spinner');
            var from = $('#from-id').val();
            var to = $('#to-id').val();
            var departure = $('#departure').data('val');
            var trip_id = btn.data('id');
            var start_time = btn.data('start-time');
            var end_time = btn.data('end-time');
            var round_trip = btn.data('round-trip');
            if($('#return').length){
                var return_date = $('#return').data('val');
            }else{
                var return_date = null;
            }
            var passengers = $('#passengers').val();
            var datas = {
                'from' : from,
                'to' : to,
                'departure' : departure,
                'return' : return_date,
                'passengers' : passengers,
                'start_time' : start_time,
                'end_time' : end_time,
                'trip_id' : trip_id,
                'round_trip' : round_trip
            };
            $('.empty-cart').hide();
            $.ajax({
                url: '/add-to-cart',
                type: "post",
                data:datas,
                success: function (data) {
                    $('#cart-items').removeClass('spinner');
                    $('#cart-items').html(data);
                    
                    $('.add-to-cart').addClass('replace-cart')
                    $('.add-to-cart').removeClass('add-to-cart ')
                    var book_text = $('.add-to-cart').data('book-text');
                    var replace_text = $('.add-to-cart').data('replace-text');
                    $('.replace-cart').text(replace_text)
                    btn.removeClass('add-to-cart')
                    btn.addClass('cursor-not-allowed bg-grey ')
                    btn.attr('disabled', 'disabled')
                    btn.text(book_text)
                    if($(".return-trips").length > 0){
                        $('html, body').animate({
                            scrollTop: $(".return-trips").offset().top
                        }, 2000);
                    }
                    
                }
            })
        }
    
        $('#cart-items').on('click','.delete-item',function(){
            $('#cart-items').addClass('spinner');
            $(this).closest(".item-wrap").css('opacity',0);
            var round_trip = $(this).data('round-trip');
            $.ajax({
                url: '/empty-cart',
                type: "post",
                data: {
                    round_trip : round_trip
                },
                success: function (data) {
                    $('#cart-items').removeClass('spinner');
                    if($('.cart_trip').length == 1){
                        $('.empty-cart').show();
                        location.reload();
                    }else{
                        $('#cart-items').html(data);
                    }
                }
            })
        });
        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;
        
            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');
        
                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
        };
        //Time range Slider
        function pad(num, size) {
            var s = num + "";
            while (s.length < size) s = "0" + s;
            return s;
        }
        var formatSecs = function (totalsecs) {
            var hour = parseInt(totalsecs / 3600, 10) % 24;
            var min = parseInt(totalsecs / 60, 10) % 60;
            var secs = totalsecs % 60;

            return pad(hour, 2) + ":" + pad(min, 2);
        };
        // mobile filter dialog
        var dialog = document.querySelector('dialog');
        var showDialogButton = document.querySelector('#filter-btn');
        if (!dialog.showModal) {
            dialogPolyfill.registerDialog(dialog);
        }
        showDialogButton.addEventListener('click', function() {
            dialog.showModal();
            setSlidersForMobile('depart');
            setSlidersForMobile('arrival');
        });
        dialog.querySelector('.close').addEventListener('click', function() {
            dialog.close();
        });
        

        function setSlidersForMobile(direction){
            if (getUrlParameter('return') != "")
            {
                arrival = getUrlParameter('return');
            } 
            $("#"+direction+"-slider-range-mobile").slider({
                range: true,
                min: 0,
                max: 82800,
                values: [0, 82800],
                step: 1800,
                slide: function (event, ui) {
                    var min = ui.values[0];
                    var max = ui.values[1];
                    $("#"+direction+"-time-start-mobile").val(formatSecs(min))
                    $("#"+direction+"-time-end-mobile").val(formatSecs(max))
                    
                }
            });
            $("#"+direction+"-time-start-mobile").val(formatSecs($("#"+direction+"-slider-range-mobile").slider("values", 0)));
            $("#"+direction+"-time-end-mobile").val(formatSecs($("#"+direction+"-slider-range-mobile").slider("values", 1)));

        }
        $('#apply-filter').click(function(){
            var from = $('#from-id').val();
            var to = $('#to-id').val();
            var departure = getUrlParameter('departure');
            var passengers = getUrlParameter('passengers');
            var arrival = "";
            // console.log($("#depart-time-start-mobile").val(), $("#depart-time-end-mobile").val())
            $.ajax({
                type: "GET",
                url: "/search/filter",
                data: {
                    direction: 'depart',
                    start_time: $("#depart-time-start-mobile").val(),
                    end_time: $("#depart-time-end-mobile").val(),
                    from : from,
                    to : to,
                    departure : departure,
                    return : arrival,
                    passengers : passengers,
                },
                cache: false,
                success: function(data){
                    $('#trips').removeClass('spinner');
                    $('#trips').html(data)
                    dialog.close();
                }
            });
        })
        
        
        setSliders('depart');
        setSliders('arrival');
        function setSliders(direction){
            var from = $('#from-id').val();
            var to = $('#to-id').val();
            var departure = getUrlParameter('departure');
            var passengers = getUrlParameter('passengers');
            var arrival = "";
            if (getUrlParameter('return') != "")
            {
                arrival = getUrlParameter('return');
            } 
            $("#"+direction+"-slider-range").slider({
                range: true,
                min: 0,
                max: 82800,
                values: [0, 82800],
                step: 1800,
                slide: function (event, ui) {
                    var min = ui.values[0];
                    var max = ui.values[1];
                    $("#"+direction+"-time-start").val(formatSecs(min))
                    $("#"+direction+"-time-end").val(formatSecs(max))
                    
                },
                stop: function( event, ui ) {
                    $('#trips').empty();
                    $('#trips').addClass('spinner');
                    $.ajax({
                        type: "GET",
                        url: "/search/filter",
                        data: {
                            direction: direction,
                            start_time: formatSecs(ui.values[0]),
                            end_time: formatSecs(ui.values[1]),
                            from : from,
                            to : to,
                            departure : departure,
                            return : arrival,
                            passengers : passengers,
                        },
                        cache: false,
                        success: function(data){
                            $('#trips').removeClass('spinner');
                            $('#trips').html(data)
                        }
                    });
                }
            });
            $("#"+direction+"-time-start").val(formatSecs($("#"+direction+"-slider-range").slider("values", 0)));
            $("#"+direction+"-time-end").val(formatSecs($("#"+direction+"-slider-range").slider("values", 1)));
        }

        $('#sort_by').on('change', function(){
            sortBy($(this).val())
        })
        function sortBy(type){
            var from = $('#from-id').val();
            var to = $('#to-id').val();
            var departure = getUrlParameter('departure');
            var passengers = getUrlParameter('passengers');
            var arrival = "";
            if (getUrlParameter('return') != "")
            {
                arrival = getUrlParameter('return');
            } 
            $.ajax({
            type: "GET",
            url: "/search/filter",
            data: {
                from : from,
                to : to,
                departure : departure,
                return : arrival,
                passengers : passengers,
                sort_by: type
            },
            cache: false,
            success: function(data){
                
                $('#trips').html(data)
            }
            });
        }
    }
  
});
